<template>
  <div id="pageContent">
    <TopBanner v-if="routeName !== 'matchDetail'" :bg-img="bgImg"
               :sub-title="mainTitle" />
    <div class="team-page">
      <div class="tab-box">
        <ul class="tab-btn-list">
          <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.name === routeName}">
            <router-link :to="{name: tab.name}">
              <span v-if="tab.title.includes('시즌권 조회/등록')">
                시즌권<br>조회/등록
              </span>
              <span v-else>{{tab.title}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <router-view class="contents"></router-view>
  </div>
</template>

<script>
import TopBanner from '@/components/Common/TopBanner.vue';

export default {
  name: 'TicketView',
  components: {
    TopBanner
  },
  data() {
    return {
      tabList: [],
      bgImg: 'ticketList',
      mainTitle: '티켓',
    }
  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });

    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      return x.meta && x.meta.title;
    });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name ? true : false
      }
      this.tabList.push(result);
    });
  },
  computed: {
    routeName() {
      if(this.$route.name === 'seasonList' || this.$route.name === 'seasonRegister') {
        return 'season';
      }else {
        return this.$route.name;
      }
    }
  }
}
</script>
